import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormatDateNobPipe } from '../pipes/format-date-nob.pipe';
import { EditFormatDatePipe } from '../pipes/edit-format-date.pipe';
import { SafeUrlPipe } from '../pipes/safe-url.pipe';
import { SafeUrlGet } from '../pipes/safe-url-get.pipe';
import { DayPipe } from '../../areas/user/profile/pages/records/create-records/pipes/day.pipe';
import { FluidHeightDirective } from '../directive/fluid-height.directive';
import { ImageRotationDirective } from '../directive/image-rotation.directive';
import { SearchContactPipe } from '../components/ui-shared-access/pipes/search-contact.pipe';
import { SearchCategoryPipe } from '../components/ui-shared-access/pipes/search-category.pipe';
import { UpdateHistoryPipe } from '../components/ui-grid/modals/record-preview-dialog/pipes/update-history.pipe';
import { DisplayTagsPipe } from '../components/ui-grid/modals/record-preview-dialog/pipes/display-tags.pipe';
import { UniqueValuesPipe } from '../pipes/unique-values.pipe';
import { DeleteConfirmationComponent } from '../components/ui-grid/modals/delete-confirmation/delete-confirmation.component';
import { IonicModule } from '@ionic/angular';
import { MatDialogModule } from '@angular/material/dialog';
import { HorizontalTrialBreadcrumbMenuComponent } from
'src/app/areas/user/profile/pages/family-tree/horizontal-trial-breadcrumb-menu/horizontal-trial-breadcrumb-menu.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HtmlToTextPipe } from '../pipes/html-to-text.pipe';
import { RecordTypeIconPipe } from '../pipes/record-type-icon.pipe';
import { DisplayProfilePicPipe } from 'src/app/areas/user/profile/pages/family-tree/pipes/display-profile-pic.pipe';

@NgModule({
    declarations: [
        FormatDateNobPipe,
        EditFormatDatePipe,
        SafeUrlPipe,
        SafeUrlGet,
        FluidHeightDirective,
        ImageRotationDirective,
        DayPipe,
        SearchContactPipe,
        SearchCategoryPipe,
        UpdateHistoryPipe,
        DisplayTagsPipe,
        UniqueValuesPipe,
        DeleteConfirmationComponent,
        HorizontalTrialBreadcrumbMenuComponent,
        HtmlToTextPipe,
        RecordTypeIconPipe,
        DisplayProfilePicPipe
    ],
    imports: [
        CommonModule,
        TranslateModule,
        IonicModule,
        MatDialogModule,
        MatTooltipModule
    ],
    exports: [
        TranslateModule,
        FormatDateNobPipe,
        EditFormatDatePipe,
        SafeUrlPipe,
        SafeUrlGet,
        FluidHeightDirective,
        ImageRotationDirective,
        DayPipe,
        SearchContactPipe,
        SearchCategoryPipe,
        UpdateHistoryPipe,
        DisplayTagsPipe,
        UniqueValuesPipe,
        DeleteConfirmationComponent,
        HorizontalTrialBreadcrumbMenuComponent,
        MatTooltipModule,
        HtmlToTextPipe,
        RecordTypeIconPipe,
        DisplayProfilePicPipe
    ]
})

export class SharedModule { }
